export default __webpack_public_path__ + "static/media/search.8e18d911.svg";